module.exports = __webpack_public_path__ + "static/media/mu.8400b4ab.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/mu.svg
// module id = 722
// module chunks = 0